/* global AirspaceLayer, AirportsLayer */

import React, {useEffect, useMemo, useRef, useState} from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import {transform} from 'ol/proj';

import {EPSG3857, EPSG4326} from '../utils/transform';

import Map, {View} from './OpenLayers';
import OpenStreetMap from './OpenStreetMap';
import WeatherImages from './WeatherImages';
import WMTSLayer from './WMTSLayer';
import Interaction from './Interaction';
import CalculationBox from './CalculationBox';
import Controls from './Controls';
import SliderBackground from './SliderBackground';
import ConfirmRegionChange from './ConfirmRegionChange';
import BrowseLayerOuter from './BrowseLayerOuter';

const Berlin = [13.4, 52.5];

const WMTSLayers = [
    AirspaceLayer,
    AirportsLayer,
];

const FlightPlanningMap = ({panelOpen, center, extent, projection, ...props}) => {
    const target = useRef(null);
    const [mounted, setMounted] = useState(false);

    useEffect(() => setMounted(true), [setMounted]);

    props.center = useMemo(() => transform(center, EPSG4326, EPSG3857), [center]);

    return (
        <div id="map-wrapper" className={classNames('row', {'panel-open': panelOpen})}>
            <BrowseLayerOuter />
            <div id="map" className="map" ref={target} />
            {mounted && (
                <Map target={target.current}>
                    <View {...props} />
                    <OpenStreetMap zIndex={0} />
                    <WeatherImages zIndex={1} />
                    {process.env.NODE_ENV === 'production' && (
                        WMTSLayers.map(name => <WMTSLayer key={name} name={name} zIndex={2} />)
                    )}
                    <Interaction zIndex={3}>
                        <CalculationBox />
                        <Controls panelOpen={panelOpen} />
                        <ConfirmRegionChange />
                    </Interaction>
                    <SliderBackground />
                </Map>
            )}
        </div>
    );
};

FlightPlanningMap.defaultProps = {
    center: Berlin,
    zoom: 5,
};

const mapStateToProps = ({center, zoom, panelOpen}) => ({center, zoom, panelOpen});

export default connect(mapStateToProps)(FlightPlanningMap);
